import { css, cx } from 'linaria';
export const betaTag = "b4tghaq";
export const BetaTag = ({
  children,
  className,
  ...args
}) => <span className={cx(className, betaTag, 'beta')} {...args}>
    {children}
  </span>;

require("../../../.linaria-cache/src/components/tags/tag-beta.linaria.module.css");